module.exports = __webpack_public_path__ + "static/media/3.8ce08490.jpg";